import React, { useEffect, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import moment from 'moment'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import useLoop from 'Shared/Hooks/useLoop'

const GasData = () => {
  const { projectInfo, profile, role, setPageLoading } = useOutletContext()

  const gas_types = projectInfo["info"]["gas"]["gas_types"]

  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()

  const [gasData, setGasData] = useState([])

  const getLatestData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/gas_detector/data`,
      returnType: "json"
    })

    body && setGasData(body.map((i) => ({
      "id": i["id"],
      "name": i["name"],
      "battery": (i["battery"]["value"] != null) ? <div>{i["battery"]["value"]} %</div> : null,
      "h2s": (i["h2s"]["value"] != null) ? <div className={i["h2s"]["alert"] ? 'text-alert' : "text-normal"}>{i["h2s"]["value"]} ppm</div> : null,
      "co": (i["co"]["value"] != null) ? <div className={i["co"]["alert"] ? 'text-alert' : "text-normal"}>{i["co"]["value"]} ppm</div> : null,
      "co2": (i["co2"]["value"] != null) ? <div className={i["co2"]["alert"] ? 'text-alert' : "text-normal"}>{i["co2"]["value"]} ppm</div> : null,
      "o2": (i["o2"]["value"] != null) ? <div className={i["o2"]["alert"] ? 'text-alert' : "text-normal"}>{i["o2"]["value"]} %</div> : null,
      "ch4": (i["ch4"]["value"] != null) ? <div className={i["ch4"]["alert"] ? 'text-alert' : "text-normal"}>{i["ch4"]["value"]} %</div> : null,
      "pm25": (i["pm25"]["value"]  != null)? <div className={i["pm25"]["alert"] ? 'text-alert' : "text-normal"}>{i["pm25"]["value"]}</div> : null,
      "temperature": (i["temperature"]["value"] != null) ? <div className={i["temperature"]["alert"] ? 'text-alert' : "text-normal"}>{i["temperature"]["value"]}</div> : null,
      "combustible_gas": (i["combustible_gas"]["value"] != null) ? <div className={i["combustible_gas"]["alert"] ? 'text-alert' : "text-normal"}>{i["combustible_gas"]["value"]}</div> : null,
      "last_update": (i["last_update"] != null) ? moment(i["last_update"]).format("YYYY-MM-DD HH:mm:ss") : null
    })))
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        getLatestData()
      ])

      setPageLoading(false)
    }

    init()
  }, [])
  
  useLoop(getLatestData, 30000)

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={gasData} count={null}
              onRowClick={(["pm", "so", "admin"].includes(role)) && function(e, row) { navigate(`./${row["id"]}`) }}
              columns={{
                "name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                "battery": { "label": t("gas_batteryLevel"), "sorting": false, "nowrap": true },
                "h2s": { "label": t("gas_h2s"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("h2s") },
                "co": { "label": t("gas_co"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("co") },
                "co2": { "label": t("gas_co2"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("co2") },
                "o2": { "label": t("gas_o2"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("o2") },
                "ch4": { "label": t("gas_ch4"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("ch4") },
                "pm25": { "label": t("gas_pm25"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("pm25") },
                "temperature": { "label": t("gas_temperature"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("temperature") },
                "combustible_gas": { "label": t("gas_combustibleGas"), "sorting": false, "nowrap": true, "hidden": !gas_types.includes("combustible_gas") },
                "last_update": { "label": t("general_lastUpdate"), "sorting": false, "nowrap": true },
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container>
  </>)
}

export default GasData
